import {
	Icon,
	Row,
	Text,
} from 'native-base';
import {
	FontAwesome5,
} from '@expo/vector-icons';

export default function DivisionHeader(props) {
	const {
			isActive = false,
		} = props;
	return <Row
				bg="primary.500"
				borderTopWidth={1}
				borderTopColor="primary.300"
				borderBottomWidth={2}
				borderBottomColor="primary.600"
				p={2}
				pl={5}
			>
				<Text
					flex={1}
					fontStyle="italic"
					alignSelf="center"
					textAlign="left"
					pl={0}
					color="#fff"
					fontSize={16}
				>{props.children}</Text>
				<Icon
					as={FontAwesome5}
					name={isActive ? 'minus' : 'plus'}
					size="xs"
					color="primary.300"
					variant="ghost"
					w={30}
					alignSelf="center"
					ml={3}
					mr={3}
				/>
			</Row>;
}
